import { z } from 'zod';
import { inferApiResultSchema, inferPaginatedApiResponse } from './infer-api';

export const IdeaAttachmentSchema = z.object({
  id: z.number(),
  ideaId: z.number(),
  name: z.string(),
  attachmentUrl: z.string().max(2083),
  mimeType: z.string(),
  size: z.number(),
  createdAt: z.date(),
  userId: z.string().max(50).nullish(),
});
export type IdeaAttachmentDto = z.infer<typeof IdeaAttachmentSchema>;

export const GetIdeaAttachmentResponseSchema = inferApiResultSchema(IdeaAttachmentSchema);
export type GetIdeaAttachmentResponseDto = z.infer<typeof GetIdeaAttachmentResponseSchema>;

export const GetIdeaAttachmentsResponseSchema = inferPaginatedApiResponse(
  z.array(IdeaAttachmentSchema),
);
export type GetIdeaAttachmentsResponseDto = z.infer<typeof GetIdeaAttachmentsResponseSchema>;

export const CreateIdeaAttachmentSchema = IdeaAttachmentSchema.omit({
  id: true,
  createdAt: true,
});
export type CreateIdeaAttachmentDto = z.infer<typeof CreateIdeaAttachmentSchema>;

export const CreateIdeaAttachmentResponseSchema = inferApiResultSchema(IdeaAttachmentSchema);
export type CreateIdeaAttachmentReponseDto = z.infer<typeof CreateIdeaAttachmentResponseSchema>;
